import React from "react";
import { Clock, Phone, Instagram, Music2, MessageCircle, Mail } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { CONTACT } from "@/data/siteConfig";

const Contact = () => {
  const { t } = useApp();

  return (
    <main data-testid="contact-page" className="pt-32 pb-24 min-h-screen bg-[#170F09]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="mb-20 max-w-3xl">
          <div className="kicker kicker-eyebrow mb-4">{t.contact.kicker}</div>
          <h1 className="section-heading text-4xl md:text-5xl lg:text-6xl mb-6">{t.contact.title}</h1>
          <p className="text-white/55">{t.contact.subtitle}</p>
        </div>

        <div className="max-w-2xl space-y-6">
          <ContactItem Icon={Clock} label="Boutique" value={t.contact.hours} />
          <ContactItem Icon={Phone} label="Concierge" value={t.contact.phone} />
          <a
            href={CONTACT.emailHref}
            data-testid="contact-email"
            className="flex gap-5 items-start border-b border-white/8 py-6 hover:border-[#C9A36B]/40 transition-colors group"
          >
            <Mail size={20} strokeWidth={1.4} className="text-[#C9A36B] shrink-0 mt-1" />
            <div>
              <div className="kicker mb-1">E-Mail</div>
              <div className="text-white/85 group-hover:text-[#C9A36B] transition-colors">{CONTACT.email}</div>
            </div>
          </a>
          <a
            href={CONTACT.whatsappHref}
            target="_blank" rel="noopener noreferrer"
            data-testid="contact-whatsapp"
            className="flex gap-5 items-start border-b border-white/8 py-6 hover:border-[#C9A36B]/40 transition-colors group"
          >
            <MessageCircle size={20} strokeWidth={1.4} className="text-[#C9A36B] shrink-0 mt-1" />
            <div>
              <div className="kicker mb-1">WhatsApp</div>
              <div className="text-white/85 group-hover:text-[#C9A36B] transition-colors">{CONTACT.whatsappDisplay}</div>
            </div>
          </a>
          <a
            href={CONTACT.instagramHref}
            target="_blank" rel="noopener noreferrer"
            data-testid="contact-instagram"
            className="flex gap-5 items-start border-b border-white/8 py-6 hover:border-[#C9A36B]/40 transition-colors group"
          >
            <Instagram size={20} strokeWidth={1.4} className="text-[#C9A36B] shrink-0 mt-1" />
            <div>
              <div className="kicker mb-1">Instagram</div>
              <div className="text-white/85 group-hover:text-[#C9A36B] transition-colors">{CONTACT.instagramHandle}</div>
            </div>
          </a>
          <a
            href={CONTACT.tiktokHref}
            target="_blank" rel="noopener noreferrer"
            data-testid="contact-tiktok"
            className="flex gap-5 items-start border-b border-white/8 py-6 hover:border-[#C9A36B]/40 transition-colors group"
          >
            <Music2 size={20} strokeWidth={1.4} className="text-[#C9A36B] shrink-0 mt-1" />
            <div>
              <div className="kicker mb-1">TikTok</div>
              <div className="text-white/85 group-hover:text-[#C9A36B] transition-colors">{CONTACT.tiktokHandle}</div>
            </div>
          </a>
          <a
            href={CONTACT.whatsappHref}
            target="_blank" rel="noopener noreferrer"
            data-testid="contact-whatsapp-cta"
            className="btn-champagne mt-4 inline-flex"
          >
            <MessageCircle size={16} /> {t.contact.whatsappCta}
          </a>
        </div>
      </div>
    </main>
  );
};

const ContactItem = ({ Icon, label, value }) => (
  <div className="flex gap-5 items-start border-b border-white/8 py-6">
    <Icon size={20} strokeWidth={1.4} className="text-[#C9A36B] shrink-0 mt-1" />
    <div>
      <div className="kicker mb-1">{label}</div>
      <div className="text-white/85">{value}</div>
    </div>
  </div>
);

export default Contact;
